import { render } from "./AddTagDialog.vue?vue&type=template&id=1aac3ca0&scoped=true&ts=true"
import script from "./AddTagDialog.vue?vue&type=script&lang=ts"
export * from "./AddTagDialog.vue?vue&type=script&lang=ts"

import "./AddTagDialog.vue?vue&type=style&index=0&id=1aac3ca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aac3ca0"]])

export default __exports__